module.exports = __webpack_public_path__ + "img/BG.54625f96.png";